import styled from 'styled-components';
import Button from '@/trio-ui/Button';
import InputText from '@/trio-ui/InputText';

export const Container = styled.div`
  width: 100%;
  margin: 64px auto 0;
  padding: 48px;
  max-width: 860px;
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 16px;
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: 26px;
  line-height: 30px;
  color: ${(props) => props.theme.colors['primary-60']};
  margin-bottom: 45px;
`;

export const InputRow = styled.div<{ extraBottomSpace?: boolean }>`
  display: flex;
  flex: 1;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors['neutral-30']};
  padding-bottom: ${(props) => (props.extraBottomSpace ? '28' : '8')}px;
  margin-bottom: 12px;

  span {
    width: 128px;
    margin-right: 32px;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: ${(props) => props.theme.colors['neutral-80']};
  }
`;

export const Label = styled.label`
  width: 128px;
  margin-right: 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const CustomInputText = styled(InputText)`
  height: 32px;
  width: 260px;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const CustomButton = styled(Button)`
  height: 32px;
  width: 260px;
  justify-content: center;
`;

export const ActionsBox = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 32px;
`;
